import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Nav, Tab, Button, Form, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaEdit, FaTrash, FaPlay, FaPause } from 'react-icons/fa';
import Logout from './../Logout/LogoutComponent';
import LogViewer from './../MasterSuppression/LogMasterSuppressionComponent';
import MasterSuppressionSetting from './../MasterSuppression/MasterSuppressionSettingComponent';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MasterSuppression.css';
import { API_MASTER_URL } from '../../config/config';

const MasterSuppressionDashboard = () => {
  const navigate = useNavigate();
  const [cronJobs, setCronJobs] = useState([]);
  const [schedule, setSchedule] = useState(new Date());
  const [command, setCommand] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [envContent, setEnvContent] = useState('');

  useEffect(() => {
    fetchEnvContent();
  }, []);

  const fetchEnvContent = async () => {
    try {
      const response = await axios.get(`${API_MASTER_URL}/env`);
      setEnvContent(response.data.envContent);
    } catch (error) {
      console.error('Error fetching .env file:', error);
      setError('Failed to fetch .env file contents');
    }
  };

  const handleLogs = () => {
    console.log('Redirecting to logs...');
  };

  const handleEnvFile = () => {
    console.log('Redirecting to Env File...');
  };

  const handleCronFile = () => {
    console.log('Redirecting to Cron File...');
  };

  const handleSettings = () => {
    console.log('Redirecting to settings...');
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  const handleAddCronJob = async () => {
    try {
      const response = await axios.post('/api/cron', { schedule, command });
      setCronJobs([...cronJobs, response.data]);
      setMessage('Cron job added successfully');
      setError('');
    } catch (error) {
      console.error('Error adding cron job:', error);
      setError('Failed to add cron job');
    }
  };

  const handleUpdateCronJob = async () => {
    if (!selectedJob) return;

    try {
      const response = await axios.put(`/api/cron/${selectedJob.id}`, { schedule, command, isActive });
      setCronJobs(cronJobs.map(job => (job.id === selectedJob.id ? response.data : job)));
      setMessage('Cron job updated successfully');
      setError('');
    } catch (error) {
      console.error('Error updating cron job:', error);
      setError('Failed to update cron job');
    }
  };

  const handleDeleteCronJob = async (id) => {
    try {
      await axios.delete(`/api/cron/${id}`);
      setCronJobs(cronJobs.filter(job => job.id !== id));
      setMessage('Cron job deleted successfully');
      setError('');
    } catch (error) {
      console.error('Error deleting cron job:', error);
      setError('Failed to delete cron job');
    }
  };

  const handleToggleActivation = async (id, isActive) => {
    try {
      const response = await axios.patch(`/api/cron/${id}`, { isActive: !isActive });
      setCronJobs(cronJobs.map(job => (job.id === id ? response.data : job)));
      setMessage('Cron job updated successfully');
      setError('');
    } catch (error) {
      console.error('Error updating cron job:', error);
      setError('Failed to update cron job');
    }
  };

  const handleEditCronJob = (job) => {
    setSelectedJob(job);
    setSchedule(job.schedule);
    setCommand(job.command);
    setIsActive(job.isActive);
  };

  const handleCancelEdit = () => {
    setSelectedJob(null);
    setSchedule('');
    setCommand('');
    setIsActive(true);
  };

  const customTimeInput = (
    <Form.Control
      type="text"
      value={schedule.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      onChange={() => {}}
      onClick={() => {}}
    />
  );

  return (
    <Container className="text-center mt-5">
      <Row>
        <Col>
          <h2>Master Suppression Dashboard</h2>
        </Col>
      </Row>
      <Row>
        <Col className="text-left">
          <Button variant="light" onClick={handleBack}>
            <FaArrowLeft /> Back to Dashboard
          </Button>
        </Col>
      </Row>
      <Row className="justify-content-center mt-4">
        <Col xs={12} md={12}>
          <Tab.Container defaultActiveKey="settings">
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="settings" onClick={handleSettings}>
                  Settings
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="logs" onClick={handleLogs}>
                  Logs
                </Nav.Link>
              </Nav.Item>
              {/*<Nav.Item>
                <Nav.Link eventKey="ENV" onClick={handleEnvFile}>
                  Env
                </Nav.Link>
              </Nav.Item>*/}
              <Nav.Item>
                <Nav.Link eventKey="CRON" onClick={handleCronFile}>
                  Cron
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="mt-3">
              <Tab.Pane eventKey="logs">
                <LogViewer />
              </Tab.Pane>
              <Tab.Pane eventKey="settings">
                <MasterSuppressionSetting />
              </Tab.Pane>
              {/*<Tab.Pane eventKey="ENV">
                <div>
                  {error ? (
                    <div className="text-danger">{error}</div>
                  ) : (
                    <Form.Group controlId="formEnvContent">
                      <Form.Control
                        as="textarea"
                        rows={10}
                        readOnly
                        value={envContent}
                        style={{ fontFamily: 'monospace' }}
                      />
                    </Form.Group>
                  )}
                </div>
              </Tab.Pane>*/}
              <Tab.Pane eventKey="CRON">
                <Form.Group controlId="formSchedule">
                  <Form.Label>Cron Schedule : </Form.Label>
                  <DatePicker
                    selected={schedule}
                    onChange={date => setSchedule(date)}
                    showTimeInput
                    dateFormat="Pp"
                    customTimeInput={customTimeInput}
                  />
                </Form.Group>
                <Form.Group controlId="formCommand">
                  <Form.Label>Command</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Command to execute"
                    value={command}
                    onChange={(e) => setCommand(e.target.value)}
                  />
                </Form.Group>
                {selectedJob ? (
                  <>
                    <Button variant="primary" onClick={handleUpdateCronJob}>
                      Update Cron Job
                    </Button>
                    <Button variant="secondary" onClick={handleCancelEdit} className="ml-2">
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Button variant="primary" onClick={handleAddCronJob}>
                    Add Cron Job
                  </Button>
                )}
                {message && <div className="text-success mt-3">{message}</div>}
                {error && <div className="text-danger mt-3">{error}</div>}
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Schedule</th>
                      <th>Command</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cronJobs.map(job => (
                      <tr key={job.id}>
                        <td>{job.id}</td>
                        <td>{job.schedule}</td>
                        <td>{job.command}</td>
                        <td>{job.isActive ? 'Active' : 'Inactive'}</td>
                        <td>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleEditCronJob(job)}
                            className="mr-2"
                          >
                            <FaEdit /> Edit
                          </Button>
                          {job.isActive ? (
                            <Button
                              variant="outline-warning"
                              size="sm"
                              onClick={() => handleToggleActivation(job.id, true)}
                              className="mr-2"
                            >
                              <FaPause /> Pause
                            </Button>
                          ) : (
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={() => handleToggleActivation(job.id, false)}
                              className="mr-2"
                            >
                              <FaPlay /> Activate
                            </Button>
                          )}
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteCronJob(job.id)}
                          >
                            <FaTrash /> Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Col>
      </Row>
      <Row>
        <Col className="text-right">
          <Logout />
        </Col>
      </Row>
    </Container>
  );
};

export default MasterSuppressionDashboard;
